import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MapColoursService} from '@core/utils/engin/geospatial-viewer/renderers/map-colours.service';
import {NbThemeService} from '@nebular/theme';
import {BucketDto} from '../../../../../../pages/geospatial-viewer/layers/metric-layer';

@Component({
    selector: 'ngx-spatial-card-category-filters',
    templateUrl: './spatial-card-category-filters.component.html',
    styleUrls: ['./spatial-card-category-filters.component.scss'],
})
export class SpatialCardCategoryFiltersComponent implements OnInit, OnChanges {
    @Input() categoryList: BucketDto[];
    // selectInLegend enables selections (and checkboxes) in the legend. When enabled, form must be provided
    @Input() selectInLegend: boolean = false;
    @Input() form?: FormGroup;

    constructor(private nbThemeService: NbThemeService) {}

    ngOnInit(): void {
        if (this.selectInLegend && !this.form?.value.categoriesSelected)
            this.form.get('categoriesSelected').setValue(this.categoryList, {
                emitEvent: false,
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.categoryList && this.selectInLegend && !this.form?.value.categoriesSelected) {
            this.form.get('categoriesSelected').setValue(this.categoryList, {
                emitEvent: false,
            });
        }
    }

    public toggleSelection(item: BucketDto): void {
        if (!this.selectInLegend) {
            return;
        }

        const currentResult = this.form.get('categoriesSelected').value || [];
        const index = currentResult.map((bucket: BucketDto) => bucket.key).indexOf(item.key);

        if (index === -1) {
            this.form.get('categoriesSelected').setValue([...currentResult, item]);
        } else {
            const updatedResult = currentResult.filter((selectedItem: BucketDto) => selectedItem.key !== item.key);

            this.form.get('categoriesSelected').setValue(updatedResult);
        }
    }

    // Check if an item is selected
    public isSelected(item: BucketDto): boolean {
        // If selection is disabled, never show unselected state
        if (!this.selectInLegend) {
            return true;
        }

        return this.form
            .get('categoriesSelected')
            .value?.map((bucket: BucketDto) => bucket.key)
            .includes(item.key);
    }

    public getBackgroundColour(
        categoryColour: string,
        isSelected: boolean,
    ): {
        'background-color': string;
        'border-color': string;
    } {
        if (!isSelected) {
            return null;
        }

        const color: string = MapColoursService.getMapCategoryColour(
            categoryColour,
            this.nbThemeService.currentTheme,
        ).color;

        return {
            'background-color': color,
            'border-color': color, //no effect
        };
    }

    public trackBy(index: number, item: BucketDto): string {
        return `${item.key}--${index}`;
    }
}
